<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <carrera-editar-form @success="success"></carrera-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <carrera-editar-form @success="success"></carrera-editar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'carrera-editar-form': require('./CarreraEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
